<template>
  <cookie-law theme="base">
      <div slot="message">
        We use cookies to ensure you get the best experience on our website.
      </div>
  </cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
  components: { CookieLaw }
}
</script>

<style>
.Cookie--base .Cookie__button {
  color: white !important;
  background: #080ed5 !important;
}
</style>